"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMobileDevice = exports.isLocalDevelopment = exports.StepIndicator = exports.OtpStep = exports.PhoneStep = exports.ValidateStep = void 0;
// Components
var ValidateStep_1 = require("./components/ValidateStep/ValidateStep");
Object.defineProperty(exports, "ValidateStep", { enumerable: true, get: function () { return __importDefault(ValidateStep_1).default; } });
var PhoneStep_1 = require("./components/PhoneStep/PhoneStep");
Object.defineProperty(exports, "PhoneStep", { enumerable: true, get: function () { return __importDefault(PhoneStep_1).default; } });
var OtpStep_1 = require("./components/OtpStep/OtpStep");
Object.defineProperty(exports, "OtpStep", { enumerable: true, get: function () { return __importDefault(OtpStep_1).default; } });
var StepIndicator_1 = require("./components/StepIndicator/StepIndicator");
Object.defineProperty(exports, "StepIndicator", { enumerable: true, get: function () { return __importDefault(StepIndicator_1).default; } });
// Utils
var utils_1 = require("./utils");
Object.defineProperty(exports, "isLocalDevelopment", { enumerable: true, get: function () { return utils_1.isLocalDevelopment; } });
Object.defineProperty(exports, "isMobileDevice", { enumerable: true, get: function () { return utils_1.isMobileDevice; } });
// Styles
require("./styles/brand-colors.css");
